import { render, staticRenderFns } from "./ShipmentPlannersForm.vue?vue&type=template&id=4084e1f5"
import script from "./ShipmentPlannersForm.vue?vue&type=script&lang=js"
export * from "./ShipmentPlannersForm.vue?vue&type=script&lang=js"
import style0 from "./ShipmentPlannersForm.vue?vue&type=style&index=0&id=4084e1f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports